export function HomeHeader() {
    return (
        <header className="fixed top-4 right-0 left-0 z-50 mx-3 rounded-lg border-b border-gray-700/50 bg-[#2A2D35]/95 backdrop-blur-sm" role="banner">
            <div className="mx-auto max-w-7xl px-4 py-4 sm:px-6 md:py-5 lg:px-8">
                <div className="flex items-center justify-between">
                    <a href="/" className="flex items-center gap-3">
                        <img src="/assets/logo.png" alt="Turkish Airlines Logo" className="h-8 w-auto md:h-10" />
                        <div className="flex items-center">
                            <span className="mx-2 text-lg font-light text-[#CBD5E1] md:mx-3 md:text-xl" aria-hidden="true">
                                |
                            </span>
                            <span className="text-md mr-2 font-semibold tracking-tight text-[#F8FAFC] md:text-xl">MCP Server</span>
                        </div>
                    </a>
                    <div className="flex items-center gap-2 rounded-full bg-[#363A42] px-3 py-2 md:px-4" role="status" aria-label="Server status">
                        <div className="h-2 w-2 animate-pulse rounded-full bg-[#22C55E]" aria-hidden="true"></div>
                        <span className="text-xs text-[#CBD5E1]">Active</span>
                    </div>
                </div>
            </div>
        </header>
    );
}
